export const FETCH_HOME = "FETCH_HOME";
export const FETCH_DETAIL = "FETCH_DETAIL";
